import type { RatingList } from "@/types"
import { RatingCategory } from "./RatingCategory"
import { t } from "i18next"
import { ratings } from "@/data"

export function RatingList() {
  return(
  <section id="software-skills" className="dark-bg">
    <div className="content-wrapper">
      <h2>{t('rating-title')}</h2>
        <div className="rating-list-container grid grid-column-auto">
        {Object.keys(ratings).map((k,i)=> {
          if (ratings[k]) {
            return(
            <RatingCategory key={i} catId={k} categoryObject={ratings[k]} />
          )
          }
        })}
        </div>    
    </div>
  </section>
  )
}